import { component, getter, action } from '../../decorators';

import WbHeader from '../header/header.vue';
import SearchAside from './search-aside/search-aside.vue';
import SearchField from './search-field/search-field.vue';
import Spinner from '../../components/common/spinner/spinner.vue';
import Paginator from '../../components/common/paginator/paginator.vue';
import Sticky from '../../components/common/sticky/sticky.vue';
import VSelect from '../../components/common/select/select.vue';
import VideoInfoDialog from '../video-info-dialog/video-info-dialog.vue';
import Checkbox from '../../components/common/checkbox/checkbox.vue';

import GridClips from './grid-clips/grid-clips.vue';
import RowClips from './row-clips/row-clips.vue';

import ComponentCreator from '../../helpers/component.creator';
import { encode, decode } from '../../transformers/base64';

import { scrollIntoViewIfNeeded } from '../../components/common/utils';
import { CLIP_TYPE_CODE } from '../../config';

import l10n from '../../transformers/l10n';

import isEqual from 'lodash/isEqual';
import reduceRight from 'lodash/reduceRight';

import {
   CLIPS_CHANGE_PAGE, CLIPS_CHANGE_PAGE_SIZE,
   CHANGE_SEARCH_VIEW_MODE, CLIPS_LOAD, SEARCH_CHANGE_TYPE,
   SYNC_SEARCH_STATE
} from '../../store/actions';

const ASIDE_TOP = 190;

const SEARCH_TYPES = [
   { value: '-1', tk: 'search.type_all' },
   { value: '0', tk: 'search.type_episode' },
   { value: '1', tk: 'search.type_clip' },
   { value: '2', tk: 'search.type_fragment' }
];

@component({
   name: 'Search',
   components: {
      WbHeader, SearchAside, SearchField, RowClips, GridClips, Spinner, Paginator, Sticky, VSelect, Checkbox
   },
   watch: {
      getLoadedClips() {
         this.hasActiveOptions = false;
      },
      getSearchViewMode() {
         this.hasActiveOptions = false;
      },
      isLoadingClips() {
         scrollIntoViewIfNeeded(this.$refs.title, true);
      },
      query: 'refreshQuery',
      '$route.query': 'reloadClipsIfNeeded'
   }
})
export default class Search {
   isFixedAside = false
   hasActiveOptions = false

   get searchTypes() {
      return SEARCH_TYPES.map(({ value, tk }) => {
         const label = l10n(tk);
         return { value, label };
      });
   }

   prevId = null

   get listComponent() {
      return this.getSearchViewMode === 'list' ? 'row-clips' : 'grid-clips';
   }

   @getter() getCurrentShowName
   @getter() isShowLoading
   @getter() isLoadingClips
   @getter() getLoadedClips
   @getter() getPageCount
   @getter() getCurrentPage
   @getter() isLarge
   @getter() getClipsCount
   @getter() getCurrentShowPict
   @getter() getLeftPixelOfPict
   @getter() getRightPixelOfPict

   @getter() getItemsPerPage
   @getter() getSearchViewMode
   @getter() getSearchType
   @getter() isEmptyReq
   @getter() getCurrentShowId

   @getter() getQueryForSerialazing

   // @action(SHOW_CLEAR_METADATA) clearMetadata
   @action(CLIPS_CHANGE_PAGE) changePage
   @action(CLIPS_CHANGE_PAGE_SIZE) changeItemsPerPage
   @action(CHANGE_SEARCH_VIEW_MODE) changeViewMode
   @action(CLIPS_LOAD) loadClips
   @action(SEARCH_CHANGE_TYPE) changeResultType
   @action(SYNC_SEARCH_STATE) syncSearcState

   get query() {
      const q = { ...this.getQueryForSerialazing };
      if (q.selectedFacets) {
         q.selectedFacets = encode(JSON.stringify(q.selectedFacets));
      }
      return q;
   }

   get cardViewTitle() {
      return l10n('search.view_card_title');
   }

   get listViewTitle() {
      return l10n('search.view_list_title');
   }

   refreshQuery() {
      const { $router, query } = this;
      $router.push({ name: 'Search', query });
   }

   reloadClipsIfNeeded() {
      const query = _convertQueryToState(this.$route.query);
      const state = { ...this.getQueryForSerialazing };

      if (isEqual(query, state)) {
         return;
      }
      this.syncSearcState(query);
   }

   _onScroll(/*e*/) {
      // this.isFixedAside = get(e, 'target.scrollingElement.scrollTop', DEFAULT_SCROLL_TOP) >= ASIDE_TOP;
      const top = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      this.isFixedAside = top >= ASIDE_TOP;
   }

   async openDetails(info) {
      const options = {};

      if (info.type === CLIP_TYPE_CODE) {
         options.episodeId = info.episodeId;
         options.clipId = info.id;
      } else if (info.type === 2) {
         options.episodeId = info.episodeId;
         options.tcIn = info.tcIn;
         options.tcOut = info.tcOut;
         options.fid = info.id;
      }
      else {
         options.episodeId = info.id;
      }

      try {
         this.$router.push(await ComponentCreator.dialog(VideoInfoDialog, options));
      } catch (e) {
         // noop
      }
   }

   openClipMaker(info) {
      const query = {};
      let eid;

      if (info.type === CLIP_TYPE_CODE) {
         eid = info.episodeId;
         query.cid = info.id;
      } else if (info.type === 2) {
         eid = info.episodeId;
         query.tcIn = info.tcIn;
         query.tcOut = info.tcOut;
         query.fid = info.id;
      }
      else {
         eid = info.id;
      }
      const params = { mid: this.getCurrentShowId, eid };
      this.$router.push({ name: 'ClipMaker', params, query });
   }

   created() {
      this.prevId = reduceRight(this.$store.state.layout.historyStack, (memo, path) => {
         if (memo) {
            return memo;
         }
         const m = this.$router.matcher.match(path);
         if (m.name === 'ClipMaker') {
            return m.query.cid || m.query.fid || m.params.eid ;
         }
         return null;
      }, null);

      const query = _convertQueryToState(this.$route.query);
      if (Object.keys(query).length) {
         this.syncSearcState(query);
      } else {
         this.refreshQuery();
         this.loadClips();
      }
   }

   destroyed() {
      // this.clearMetadata();
      document.removeEventListener('scroll', this._onScroll);
   }

   mounted() {
      document.addEventListener('scroll', this._onScroll);
   }
}

function _convertQueryToState(query) {
   const state = { ...query };
   // state.textless = `${state.textless}` === 'true';

   if (!Array.isArray(state.qprops)) {
      state.qprops = state.qprops ? [state.qprops] : [];
   }

   if (state.selectedFacets) {
      try {
         const str = decode(state.selectedFacets);
         state.selectedFacets = JSON.parse(str);
      } catch (e) {
         //
      }
   }
   return state;
}
